import React, { useEffect, useState } from "react";
import { ClockIcon } from "lucide-react";
const START_SECONDS = 17 * 60 + 34;
type CountdownProps = {
  dark?: boolean;
};
export function Countdown({
  dark = false
}: CountdownProps) {
  const [seconds, setSeconds] = useState(START_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSeconds(s => s <= 1 ? START_SECONDS : s - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const h = Math.floor(seconds / 3600);
  const m = Math.floor(seconds % 3600 / 60);
  const s = seconds % 60;
  const parts = [{
    value: h,
    label: "Hours"
  }, {
    value: m,
    label: "Min"
  }, {
    value: s,
    label: "Sec"
  }];
  return <div className="mt-6 flex flex-col items-center" role="timer" aria-live="off" data-id="element-89" data-mp="371zxdn5q21et">
      <p className={`flex items-center gap-2 text-sm font-bold uppercase tracking-wide ${dark ? "text-gold" : "text-alert"}`} data-id="element-90" data-mp="10btphzm3fkwu">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-91" data-mp="159by1ow77y4b" />
        Special offer ends in:
      </p>
      <div className="mt-3 flex items-start gap-2" data-id="element-92" data-mp="xz3kdw3aiu7q">
        {parts.map((p, i) => <React.Fragment key={p.label} data-id="element-93" data-mp="t1tp3zt7zobz" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-94" data-mp="17qq4yj1iq5n5">
              <span className={`flex h-16 w-16 items-center justify-center rounded-xl font-display text-3xl font-extrabold tabular-nums sm:h-[72px] sm:w-[72px] sm:text-4xl ${dark ? "bg-white text-night" : "bg-night text-white"}`} data-id="element-95" data-mp="17q6jwtgkn14w">
                {String(p.value).padStart(2, "0")}
              </span>
              <span className={`mt-1 text-[11px] font-semibold uppercase tracking-wide ${dark ? "text-white/70" : "text-ink-muted"}`} data-id="element-96" data-mp="o41u2wxa3m3k">
                {p.label}
              </span>
            </div>
            {i < parts.length - 1 && <span className={`mt-3 font-display text-3xl font-extrabold ${dark ? "text-white" : "text-night"}`} aria-hidden="true" data-id="element-97" data-mp="1vfslfnkf1sg2">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}